import axios from "axios";
import { useEffect, useState } from "react";

const linkCache = {};

export function useExternalLink(name) {
    const [url, setUrl] = useState(linkCache[name] || null);

    useEffect(() => {
        if (linkCache[name]) return;

        axios.get(`/externallink/${name}`)
            .then(r => {
                linkCache[name] = r.data;
                setUrl(r.data);
            });
    }, [name]);

    return url;
}
